import { notification } from "antd";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import "../../../LeadNew/LeadDetail/LenderPrivacyPolicy/LenderPrivacyPolicy.scss";
import PrivacyPolicyPanel from "./PrivacyPolicyPanel";
import API_SERVICE from "shared/services/api-service";
import LenderDisbursedMain from "../LenderDisbursed/LenderDisbursedMain";

interface ILenderPrivacyPolicy {
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  leadData?: any;
  getLeadById: any;
  isShowDisbursed:any;
  setIsShowDisbursed:any;
  selectedLenderList:any;
  lenderDisbursedHandler:any;
  getRedirectURLLink:any;
  getDownloadLetterForICICI:any;
  loadingUpdate:any;
  productPlanName:any;
  setProductPlanName:any
  productPlanId:any;
  setProductPlanId:any
  annualFee:any;
  selectedLender:any;
  selectedLenderName: any;
  setSelectedLenderName: any;
}

const LenderPrivacyPolicy: React.FC<ILenderPrivacyPolicy> = (
  props: ILenderPrivacyPolicy
) => {
  const { 
    leadData, 
    setIsLoading, 
    getLeadById, 
    isShowDisbursed,
    setIsShowDisbursed,
    selectedLenderList,
    lenderDisbursedHandler,
    getRedirectURLLink,
    getDownloadLetterForICICI,
    loadingUpdate,
    productPlanName, 
    setProductPlanName,
    productPlanId, 
    setProductPlanId,
    annualFee,
    selectedLender,
    selectedLenderName,
    setSelectedLenderName,
   } = props;
  const [lenderListInsurer, setLenderListInsurer] = useState([] as any);
  const [lenders, setLenders] = useState([
    ...leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails,
  ] as any);
  const [lendersData, setLendersData] = useState([] as any);
  // const [selectedLenderName, setSelectedLenderName] = useState("");
  useEffect(() => {
    setLenders([
      ...leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails,
    ]);
    getProductsPlans();
  }, [leadData]);

  useEffect(() => {
    getLenders();
  }, [])

  const getIPData = async () => {
    const { data } = await API_SERVICE.getIPData();
    return data.ip
  };

  const getLenders = async () => {
    setIsLoading(true);

    let param: any = {
        status: "Active",
        loanProductId: leadData?.loanProductId,
        caseId:leadData?.caseDetails?.caseId,
        pageNo: 1,
        pageSize: 200,
    }

    if(leadData?.loanType==="Credit Card"){
        param = {
            ...param,
            systemIp: await getIPData(),
            source: "CASE",
            refreshAggregatorOffer: false
        }
    }

    API_SERVICE.getLenders(param)
        .then(({ data }) => {
            if (data?.payload?.content) {
                const datas = data?.payload?.content;
                setLendersData(datas)
            }
        })
        .catch((e: any) => {})
        .finally(() => setIsLoading(false));
};


  const getProductsPlans = () => {
    setIsLoading(true);
    let payload = {
      lenderIds: lenders?.map((lender: any) => lender?.lenderInfoId)?.join(","),
      loanProductId: leadData?.loanProductId,
      status: "ACTIVE"
    };
    API_SERVICE.getLenderListInsurer(payload)
      .then(({ data }) => setLenderListInsurer(data?.payload))
      .catch((e: any) => {
          notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setIsLoading(false));
  };

  const updateCase = (lender) => {
    setSelectedLenderName(lender?.lenderName)
    setIsLoading(true);
    const payload = {
      lenderDetails: [lender],
      comment: "",
    };

    let updatedStatus = lender.status;

     
    if (lender.status === 'POLICY_ISSUED') {
      updatedStatus = "POLICY_ISSUED";
    }
     else if (lender.status === 'UNDERWRITING_REJECT') {
      updatedStatus = "POLICY_STATUS_REJECTED";  
    } 
    else if (lender.status === 'WITHDRAWN') {
      updatedStatus = "POLICY_STATUS_WITHDRAWN";  
    } 
    else if (lender.status === 'COUNTER_OFFER') {
      updatedStatus = "POLICY_STATUS_COUNTER_OFFER";  
    } else  if (lender.status === 'SANCTIONED' || (lender.status === "REJECTED") || (lender.status === "WITHDRAWN")|| (lender.status === "PENDENCY")) {
      updatedStatus = "LENDER_DECISION";
    }
     API_SERVICE.updateCase(
      leadData?.caseDetails?.caseId,
      updatedStatus,
      payload,
      leadData?.loanProductId
    )
      .then(({ data }) => {
        if (data) {
          notification.success({ message: data.message });          
            const tmpLender = lenders.map((lender: any) => {
              const res =
                data?.payload?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.at(
                  0
                );
              if (lender.lenderInfoId == res.lenderInfoId) {
                return res;
              }
              return lender;
            });
            setLenders(tmpLender);
            if(leadData?.loanType==="Credit Card"){
              setIsShowDisbursed(true)
              setIsLoading(false)
             }
          getLeadById()
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        setIsLoading(false);
      })
      .finally(() => setIsLoading(false));
  };

  const actionAdd = (i: number, iDetails: any) => {
    const tmpLender1 = lenders.at(i);
    const iDet = [...iDetails];
    iDet.push({});
    tmpLender1.insuranceDetails = { insuranceDetails: iDet };
    tmpLender1.status = "";
    tmpLender1.comments = "";
    const tmpLenders = [...lenders];
    tmpLenders[i] = tmpLender1;
    setLenders(tmpLenders);
  };

  const renderDisbursed = () => (
    <LenderDisbursedMain
      setIsLoading={setIsLoading}
      leadData={leadData}
      selectedLenderList={selectedLenderList}
      lenderDisbursedHandler={lenderDisbursedHandler}
      getRedirectURLLink={getRedirectURLLink}
      getDownloadLetterForICICI={getDownloadLetterForICICI}
      loadingUpdate={loadingUpdate}
      selectedLenderName={selectedLenderName}
      productPlanName={productPlanName}
      setProductPlanName={setProductPlanName}
      productPlanId={productPlanId}
      />
  );

  const renderLenderPrivacyPolicy = () =>{
  return (
    <div>
      <div
        className="leadDisburse-Detail-scroll"
        style={{ maxHeight: "400px" }}
      >
        <ul style={{ listStyle: "none", padding: "0px" }}>
          {lenders?.map((lender: any, i: any) => {
            const tmpInsurer = lenderListInsurer?.find(
              (insurer: any) => insurer?.lenderId === lender?.lenderInfoId
            );
            const plans = tmpInsurer?.productPlanDetails;
            const iDetails = lender?.insuranceDetails?.insuranceDetails;
            const showAdd =
              (plans?.length ?? 0) > 1 &&
              (plans?.length ?? 0) > (iDetails?.length ?? 0);

            const lenderFullData = lendersData?.find((lenderItem: any) => lenderItem?.lenderInfoId === lender?.lenderInfoId);
            
            if ((iDetails?.length ?? 0) === 0 || (leadData?.loanType==="Credit Card"  && selectedLender?.subProductDetails != null)) {
              return (
                <PrivacyPolicyPanel
                  lender={lender}
                  productPlans={plans}
                  lenderIndex={i}
                  updateCase={updateCase}
                  showAdd={showAdd}
                  loanType={leadData?.loanType}
                  onClickAdd={() => actionAdd(i, [])}
                  setIsLoading={setIsLoading}
                  leadData={leadData}
                  productPlanName={productPlanName}
                  setProductPlanName={setProductPlanName}
                  productPlanId={productPlanId}
                  setproductPlanId={setProductPlanId}
                  annualFee={annualFee}
                  selectedLender={selectedLender}
                  lenderFullData={lenderFullData}
                />
              );
            } else {
              return iDetails?.map((detail: any) => {
                const tmpLender = { ...lender };
                tmpLender.insuranceDetails = detail;
                return (
                  <PrivacyPolicyPanel
                    lender={tmpLender}
                    productPlans={plans}
                    lenderIndex={i}
                    updateCase={updateCase}
                    showAdd={showAdd}
                    loanType={leadData?.loanType}
                    onClickAdd={() => actionAdd(i, iDetails)}
                    setIsLoading={setIsLoading}
                    leadData={leadData}
                    productPlanName={productPlanName}
                    setProductPlanName={setProductPlanName}
                    productPlanId={productPlanId}
                    setproductPlanId={setProductPlanId}
                    annualFee={annualFee}
                    selectedLender={selectedLender}
                    lenderFullData={lenderFullData}
                  />
                );
              });
            }
          })}
        </ul>
      </div>
    </div>
    
  );
}
  return isShowDisbursed ? renderDisbursed() : renderLenderPrivacyPolicy();
};

export default LenderPrivacyPolicy;
